import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import breadcrumbs from "common/Breadcrumbs"
import LeadTypeTable from "./LeadTypeTable"
import { Title } from "chart.js"
import { exportDataExcel } from "components/Common/ExportData"
import DeleteModel from "common/deleteModel/deleteModel"

function LeadTypeList() {
    document.title = `Lead Types | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    const navigate = useNavigate()

    // useStates
    const [modal, setModal] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isEdit, setIsEdit] = useState(false)
    const [leadTypeId, setLeadTypeId] = useState(0)

    // filter data for lead-type
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // lead-type list api
    const leadTypeListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Lead/type/list", '').then(({ data, status }) => {
            if (status === 200) {
                setTableData(data)
                setTotalRecords(data?.length)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // lead-type list api useEffect
    useEffect(() => {
        leadTypeListApi()
    }, [])

    // Create lead-type handler
    const handleLeadTypeClick = () => {
        toggle()
    }


    const handleDelete = (Id) => {
        setScreenLoad(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this lead type permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Lead/type/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Lead type deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Lead Type",
                                    text: data,
                                })
                            }
                            setScreenLoad(false)
                        }
                    )
                } else {
                    setScreenLoad(false)
                }
            })
        }

    }

    const handleEdit = (data) => {
        setIsEdit(true)
        toggle()
        validation.setFieldValue("LeadType", data?.Name)
        setLeadTypeId(data?.Id)
    }

    // Colors Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            LeadType: "",
        },
        validationSchema: Yup.object({
            LeadType: Yup.string().required("The lead type is required"),
        }),
        onSubmit: values => {
            setformSumitLoading(true)
            if (values) {

                isEdit ?
                    putApi(`Lead/type/update`, {
                        Id: leadTypeId,
                        Title: values.LeadType,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            leadTypeListApi()
                            validation.handleReset()
                        }
                    })
                    :


                    postApi("Lead/type/create", { Title: values.LeadType }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            leadTypeListApi()
                            validation.handleReset()
                        }
                    })
            }
        },
    })

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        validation.handleReset()
    }


    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEdit(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    )
    const [isMobile, setisMobile] = useState(window.innerWidth < 924)

    function writeDataToExcel() {
        setIsLoading(true)
        let header = ["Name"];
        const mainTitle = "Lead Type";
        const widthObj = [{
            Key: "A",
            Value: 30,
        },
        ]
        const extention = "Lead_Type.xlsx"
        let excelSheetData = []
        for (let index = 0; index < tableData.length; index++) {
            let dataObj = {
                Name: tableData[index].Name,
            }
            excelSheetData.push(dataObj)
        }
        var fields = Object.keys(excelSheetData[0]);
        var sheetData = excelSheetData.map(function (row) {
            return fields.map(function (fieldName) {
                return row[fieldName];
            });
        });
        setIsLoading(false)
        sheetData.unshift(header);
        exportDataExcel(sheetData, mainTitle, widthObj, extention)
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <LeadTypeTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddLeadTypeList={true}
                            handleLeadTypeClick={handleLeadTypeClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            writeDataToExcel={writeDataToExcel}
                        />

                        <Modal
                            isOpen={modal}
                            toggle={toggle}
                            centered={true}
                            size="small"
                            style={{ width: !isMobile ? "400px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={toggle} tag="h5">
                                    {isEdit ? "Update Lead Type" : "Create Lead Type"}
                                </ModalHeader>
                                <ModalBody>
                                    <Form
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                        onReset={e => {
                                            e.preventDefault
                                            validation.handleReset()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <FormGroup className="mb-2">
                                                <Label htmlFor="validationCustom03" className="required">
                                                    Lead Type
                                                </Label>
                                                <Input
                                                    name="LeadType"
                                                    placeholder="Enter Lead Type"
                                                    type="text"
                                                    className="form-control-sm"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.LeadType || ""}
                                                    invalid={
                                                        validation.touched.LeadType && validation.errors.LeadType
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validation.touched.LeadType && validation.errors.LeadType ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.LeadType}
                                                    </FormFeedback>
                                                ) : null}
                                            </FormGroup>
                                        </Row>
                                        <div className="text-end">
                                            <Button
                                                lead-type="secondary"
                                                className="btn btn-primary me-2 btn-sm "
                                                type="reset"
                                                color="secondary"
                                            >
                                                Reset
                                            </Button>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    lead-type="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="submit"
                                                >
                                                    Submit
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </ModalBody>
                            </div>
                        </Modal>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
LeadTypeList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default LeadTypeList
